// Define an interface for the API response
interface UpdatePostViewsResponse {
    data: {
        updatePostViews: {
            views: number;
        };
    };
    success: boolean;
    message?: string;
    // Add other fields as needed based on your API response
}

// Define the function with type annotations
const updatePostViews = async (postId: number | string): Promise<UpdatePostViewsResponse> => {
    const response = await fetch('/api/post/update-post-views/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postId }),
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Parse and return the JSON response with the defined type
    const data: UpdatePostViewsResponse = await response.json();
    return data;
};

export default updatePostViews;
